import React, { useState } from "react";
import { useEmailTemplates } from "../hooks/useEmailTemplates";
import EmailTemplateTable from "./EmailTemplateTable";
import EmailTemplateForm from "./EmailTemplateForm";
import EmailTemplateSkeleton from "./EmailTemplateSkeleton";

export default function EmailTemplatesPage() {

  const {
    templates,
    loading,
    createTemplate,
    updateTemplate,
    toggleStatus
  } = useEmailTemplates();

  const [editing, setEditing] = useState(null);

  return (
    <div sty className="p-6" style={{position:"relative",zIndex:99999}}>

      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Email Templates</h1>
        <button
          onClick={() => setEditing({})}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          + Create Template
        </button>
      </div>

      {loading ? (
        <EmailTemplateSkeleton />
      ) : (
        <EmailTemplateTable
          templates={templates}
          onEdit={setEditing}
          onToggleStatus={toggleStatus}
        />
      )}

      {editing !== null && (
        <EmailTemplateForm
          template={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (data) => {
            if (editing.id) {
              await updateTemplate(editing.id, data);
            } else {
              await createTemplate(data);
            }
            setEditing(null);
          }}
        />
      )}
    </div>
  );
}